import React, { useEffect, useState } from 'react';

import ReactPortal from '@demmi-ui/ReactPortal';

import NotificationsPanelContent from './NotificationsPanelContent';
import {
  NotificationCustomerWithVendor,
  NotificationVendorWithCustomer,
} from '@models/notifications.model';

interface Props {
  isOpen: boolean;
  onExited: () => void;
  notificationsVendor: NotificationVendorWithCustomer[];
  notificationsCustomer: NotificationCustomerWithVendor[];
}

const NotificationsPanel: React.FC<Props> = ({
  isOpen,
  onExited,
  notificationsVendor,
  notificationsCustomer,
}) => {
  const CSSBlock = 'notifications-panel';

  if (!isOpen) return null;
  const [modalClass, setModalClass] = useState('');

  useEffect(() => {
    requestAnimationFrame(() => setModalClass(`${CSSBlock}--visible`));
  }, []);

  const onClose = () => {
    setModalClass('');
    setTimeout(() => onExited(), 300);
  };

  useEffect(() => {
    const onKeyDown = (e: globalThis.KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <ReactPortal wrapperId="notifications-panel">
      <div className={`${CSSBlock} ${modalClass}`}>
        <div className={`${CSSBlock}__backdrop`} onClick={() => onClose()}></div>
        <NotificationsPanelContent
          onNavigate={() => onClose()}
          notificationsVendor={notificationsVendor}
          notificationsCustomer={notificationsCustomer}
        />
      </div>
    </ReactPortal>
  );
};

export default NotificationsPanel;
